import { Logging, ResponseError, TaxPayer } from '@vcd-ecm-ui/Common';

// eslint-disable-next-line import/prefer-default-export
export const adjustErrorDescription = (responseError: ResponseError, taxpayer: TaxPayer): ResponseError => {
  Logging.Info('responseError', responseError.statusCode, responseError.message);

  if (responseError.statusCode === 409) {
    if (responseError.message.includes('Parent taxpayer and child taxpayer must be equal but they were not.')) {
      // eslint-disable-next-line no-param-reassign
      responseError.message = 'The Parent Taxpayer and Child Taxpayer must be equal but they are not.';
    } else if (responseError.message.includes('Customer code with taxpayer definition already exists:')) {
      // eslint-disable-next-line no-param-reassign, max-len
      responseError.message = taxpayer ? 'A Customer with the Customer Code and Taxpayer (Code, Division, Department, Partition) definition already exists.' : 'A Customer with the Customer Code already exists.';
    } else if (responseError.message.includes('Parent taxpayer and child taxpayer must have the same uuid.')) {
      // eslint-disable-next-line no-param-reassign, max-len
      responseError.message = 'The Parent Taxpayer and Child Taxpayer must be equal but they are not.';
    }
  }

  if (responseError.statusCode === 400) {
    if (responseError.message.includes('.name\': rejected value [null]')) {
      // eslint-disable-next-line no-param-reassign
      responseError.message = 'The Contact Name is required for all Customer contacts.';
    }
  }

  return responseError;
};
